import React from 'react';
import { twMerge } from 'tailwind-merge';

export default function EmptyState({
  icon,
  title,
  subtitle,
  containerClassName,
}: {
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
  containerClassName?: string;
}): JSX.Element {
  return (
    <div className={twMerge('flex w-full flex-col items-center justify-center gap-4 py-12', containerClassName)}>
      <div className="mb-2">{icon}</div>
      <h3 className="mb-1 text-lg font-semibold text-primary">{title}</h3>
      {subtitle && <p className="text-details/70">{subtitle}</p>}
    </div>
  );
}
